"use client";

import { useState } from "react";
import { DEFAULT_UI } from "@/lib/ui-defaults";
import { useUI } from "@/lib/ui-context";

export interface FreeVhfReadTranscriptProps {
  /** Full transcript text to show when expanded */
  transcriptText: string;
  /** Optional id for the block (a11y) */
  id?: string;
}

/**
 * Modules 1 & 2: optional "Read what was said"  -  collapsible block that shows
 * the full transcript after the user has listened and done the self-report.
 */
export default function FreeVhfReadTranscript({
  transcriptText,
  id = "free-vhf-read-transcript",
}: FreeVhfReadTranscriptProps) {
  const ui = useUI();
  const buttonLabel =
    ui.freeVhf?.transcript?.readLabel ?? DEFAULT_UI.freeVhf?.transcript?.readLabel ?? "";
  const [expanded, setExpanded] = useState(false);

  return (
    <div id={id} className="space-y-3">
      {!expanded ? (
        <button
          type="button"
          onClick={() => setExpanded(true)}
          className="inline-flex items-center min-h-[44px] px-4 py-2 rounded-lg border border-[var(--neutral-border)] text-content font-medium hover:bg-neutral-50 focus-visible:outline-2 focus-visible:outline-interactive-focus focus-visible:outline-offset-2"
        >
          {buttonLabel}
        </button>
      ) : (
        <div
          className="rounded-lg border border-[var(--neutral-border)] bg-neutral-50 px-4 py-3 text-sm text-muted content-prose whitespace-pre-wrap"
          role="region"
          aria-label={buttonLabel}
        >
          {transcriptText}
        </div>
      )}
    </div>
  );
}
